var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabCalendarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.3913H23V17.7391C23 21.1969 20.0451 24 16.4 24H7.6C3.95492 24 1 21.1969 1 17.7391V9.3913Z",
    fill: "currentColor",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 0.521739C7.6 0.23359 7.84624 0 8.15 0C8.45376 0 8.7 0.233591 8.7 0.521739V5.73913C8.7 6.02728 8.45376 6.26087 8.15 6.26087C7.84624 6.26087 7.6 6.02728 7.6 5.73913V0.521739Z",
    fill: "currentColor",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 0.521739C15.3 0.23359 15.5462 0 15.85 0C16.1538 0 16.4 0.233591 16.4 0.521739V5.73913C16.4 6.02728 16.1538 6.26087 15.85 6.26087C15.5462 6.26087 15.3 6.02728 15.3 5.73913V0.521739Z",
    fill: "currentColor",
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.34783C1 4.89004 3.95492 2.08696 7.6 2.08696H16.4C20.0451 2.08696 23 4.89004 23 8.34783H1Z",
    fill: "currentColor",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabCalendarFilled);
export default __webpack_public_path__ + "static/media/tab_calendar_filled.974c2c21.svg";
export { ForwardRef as ReactComponent };